import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, type MenuProps, Modal } from 'antd';
import { UnlockOutlined, LockOutlined, ExclamationCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { useSetBlockClientUser } from 'api/client-users/use-set-block-client-user';
import type { TDropdownChangeInfo } from 'types/dropdown-change-info';
import type { IClientUserControlProps } from './types';
import { getControlTranslationKeys } from './utils';

export const ClientUserControl: React.FC<IClientUserControlProps> = (props) => {
  const { clientUserId, isBlocked } = props;
  const { t } = useTranslation();

  const { modalContentKey, labelContentKey } = getControlTranslationKeys(isBlocked);
  const modalContent = t(modalContentKey);
  const labelContent = t(labelContentKey);

  const [modal, contextHolder] = Modal.useModal();
  const [isActiveControl, setIsActiveControl] = useState(false);
  const { mutateAsync: setBlockClientUser } = useSetBlockClientUser(clientUserId);

  const deactivateWithTimeout = () => {
    setTimeout(() => setIsActiveControl(false), 300);
  };

  const handleConfirm = async () => {
    await setBlockClientUser({ isBlock: !isBlocked });
    deactivateWithTimeout();
  };

  const confirm = () => {
    modal.confirm({
      title: t('common:confirm'),
      icon: <ExclamationCircleOutlined />,
      content: modalContent,
      okText: labelContent,
      cancelText: t('common:cancel'),
      onCancel: deactivateWithTimeout,
      onOk: handleConfirm,
      maskClosable: true,
    });
  };

  const handleDropdownClick: MenuProps['onClick'] = () => {
    confirm();
  };

  const handleDropdownOpenChange = (value: boolean, info: TDropdownChangeInfo) => {
    if (info.source === 'trigger') {
      setIsActiveControl(value);
    }
  };

  return (
    <>
      <Dropdown
        trigger={['click']}
        menu={{
          items: [
            {
              key: labelContent,
              label: labelContent,
              icon: isBlocked ? <UnlockOutlined /> : <LockOutlined />,
            },
          ],
          onClick: handleDropdownClick,
        }}
        placement='bottomLeft'
        onOpenChange={handleDropdownOpenChange}>
        <MoreOutlined style={{ fontSize: 20 }} />
      </Dropdown>
      {isActiveControl ? contextHolder : null}
    </>
  );
};
